// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"menu-item_3wLbDq","menuItem":"menu-item_3wLbDq","txt":"txt_3ytNo5"};